<script>
import HarnessSelectionStats from './HarnessSelectionStats.vue';
export default {
  name: 'FormGuideSelectionStats',
  components: {
    HarnessSelectionStats,
  },
  props: {
    stats: {
      type: Object,
      required: true,
    },
    raceType: {
      type: String,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isHarness() {
      return this.raceType === 'harness';
    },
  },
};
</script>


<template>
  <div class="form-guide-selection-stats">
    <template v-if="isHarness">
      <HarnessSelectionStats :selection-stats="stats" :is-mobile="isMobile" />
    </template>
  </div>
</template>
